/**
 * !⚠️ The order of the elements in these arrays are critical.
 * Each level (e.g., Level 3, Level 4, etc.) is sequentially represented,
 * with one entry per level.
 *
 * Changing the order will break logic that relies on this structure,
 * such as calculations for slicing or indexing based on levels.
 *
 * Always maintain the current order:
 * [Level 3, Level 4, Level 5, ...] for each level.
 */
export const wholeHouseFoundationDefaultLevelIds = [
	'wholeHouseFoundationLevel0',
	'wholeHouseFoundationLevel1',
] as const;

export const wholeHouseFoundationAdditionalLevelIds = [
	'wholeHouseFoundationLevel2',
	'wholeHouseFoundationLevel3',
	'wholeHouseFoundationLevel4',
	'wholeHouseFoundationLevel5',
	'wholeHouseFoundationLevel6',
	'wholeHouseFoundationLevel7',
] as const;

export const wholeHouseFoundationLevelIds = [
	...wholeHouseFoundationDefaultLevelIds,
	...wholeHouseFoundationAdditionalLevelIds,
];

export const wholeHouseFoundationBasementDefaultLevelIds = [
	'wholeHouseFoundationBasementLevel0',
	'wholeHouseFoundationBasementLevel1',
] as const;

export const wholeHouseFoundationBasementAdditionalLevelIds = [
	'wholeHouseFoundationBasementLevel2',
	'wholeHouseFoundationBasementLevel3',
	'wholeHouseFoundationBasementLevel4',
	'wholeHouseFoundationBasementLevel5',
	'wholeHouseFoundationBasementLevel6',
	'wholeHouseFoundationBasementLevel7',
] as const;

export const wholeHouseFoundationBasementLevelIds = [
	...wholeHouseFoundationBasementDefaultLevelIds,
	...wholeHouseFoundationBasementAdditionalLevelIds,
];

export const wholeHouseFramingDefaultLevelIds = [
	'wholeHouseFramingLevel0',
	'wholeHouseFramingLevel1',
] as const;
export const wholeHouseFramingAdditionalLevelIds = [
	'wholeHouseFramingLevel2',
	'wholeHouseFramingLevel3',
	'wholeHouseFramingLevel4',
	'wholeHouseFramingLevel5',
	'wholeHouseFramingLevel6',
	'wholeHouseFramingLevel7',
] as const;

export const wholeHouseFramingLevelIds = [
	...wholeHouseFramingDefaultLevelIds,
	...wholeHouseFramingAdditionalLevelIds,
];

export const wholeHouseFlooringDefaultLevelIds = [
	'wholeHouseFlooringLevel0',
	'wholeHouseFlooringLevel1',
] as const;

export const wholeHouseFlooringAdditionalLevelIds = [
	'wholeHouseFlooringLevel2',
	'wholeHouseFlooringLevel3',
	'wholeHouseFlooringLevel4',
	'wholeHouseFlooringLevel5',
	'wholeHouseFlooringLevel6',
	'wholeHouseFlooringLevel7',
] as const;

export const wholeHouseIntFramingDefaultLevelIds = [
	'wholeHouseIntFramingLevel0',
	'wholeHouseIntFramingLevel1',
] as const;

export const wholeHouseIntFramingAdditionalLevelIds = [
	'wholeHouseIntFramingLevel2',
	'wholeHouseIntFramingLevel3',
	'wholeHouseIntFramingLevel4',
	'wholeHouseIntFramingLevel5',
	'wholeHouseIntFramingLevel6',
	'wholeHouseIntFramingLevel7',
] as const;

export const wholeHouseIntFramingLevelIds = [
	...wholeHouseIntFramingDefaultLevelIds,
	...wholeHouseIntFramingAdditionalLevelIds,
];

export const wholeHouseExtFramingDefaultLevelIds = [
	'wholeHouseExtFramingLevel0',
	'wholeHouseExtFramingLevel1',
] as const;

export const wholeHouseExtFramingAdditionalLevelIds = [
	'wholeHouseExtFramingLevel2',
	'wholeHouseExtFramingLevel3',
	'wholeHouseExtFramingLevel4',
	'wholeHouseExtFramingLevel5',
	'wholeHouseExtFramingLevel6',
	'wholeHouseExtFramingLevel7',
] as const;

export const wholeHouseExtFramingLevelIds = [
	...wholeHouseExtFramingDefaultLevelIds,
	...wholeHouseExtFramingAdditionalLevelIds,
];

export const wholeHouseFlooringLevelIds = [
	...wholeHouseFlooringDefaultLevelIds,
	...wholeHouseFlooringAdditionalLevelIds,
];

export const wholeHouseDecksAndPorchesDefaultLevelIds = [
	'wholeHouseDecksAndPorchesLevel1',
] as const;

export const wholeHouseDecksAndPorchesAdditionalLevelIds = [
	'wholeHouseDecksAndPorchesLevel2',
	'wholeHouseDecksAndPorchesLevel3',
	'wholeHouseDecksAndPorchesLevel4',
	'wholeHouseDecksAndPorchesLevel5',
	'wholeHouseDecksAndPorchesLevel6',
	'wholeHouseDecksAndPorchesLevel7',
] as const;

export const wholeHouseDecksAndPorchesLevelIds = [
	...wholeHouseDecksAndPorchesDefaultLevelIds,
	...wholeHouseDecksAndPorchesAdditionalLevelIds,
];

export const wholeHouseWindowsDefaultLevelIds = [
	'wholeHouseWindowsLevel0',
	'wholeHouseWindowsLevel1',
] as const;

export const wholeHouseWindowsAdditionalLevelIds = [
	'wholeHouseWindowsLevel2',
	'wholeHouseWindowsLevel3',
	'wholeHouseWindowsLevel4',
	'wholeHouseWindowsLevel5',
	'wholeHouseWindowsLevel6',
	'wholeHouseWindowsLevel7',
] as const;

export const wholeHouseWindowsLevelIds = [
	...wholeHouseWindowsDefaultLevelIds,
	...wholeHouseWindowsAdditionalLevelIds,
];

export const wholeHouseDoorsDefaultLevelIds = [
	'wholeHouseDoorsLevel0',
	'wholeHouseDoorsLevel1',
] as const;

export const wholeHouseDoorsAdditionalLevelIds = [
	'wholeHouseDoorsLevel2',
	'wholeHouseDoorsLevel3',
	'wholeHouseDoorsLevel4',
	'wholeHouseDoorsLevel5',
	'wholeHouseDoorsLevel6',
	'wholeHouseDoorsLevel7',
] as const;

export const wholeHouseDoorsLevelIds = [
	...wholeHouseDoorsDefaultLevelIds,
	...wholeHouseDoorsAdditionalLevelIds,
];

export const wholeHouseCeilingsDefaultLevelIds = [
	'wholeHouseCeilingsLevel0',
	'wholeHouseCeilingsLevel1',
] as const;

export const wholeHouseCeilingsAdditionalLevelIds = [
	'wholeHouseCeilingsLevel2',
	'wholeHouseCeilingsLevel3',
	'wholeHouseCeilingsLevel4',
	'wholeHouseCeilingsLevel5',
	'wholeHouseCeilingsLevel6',
	'wholeHouseCeilingsLevel7',
] as const;

export const wholeHouseCeilingsLevelIds = [
	...wholeHouseCeilingsDefaultLevelIds,
	...wholeHouseCeilingsAdditionalLevelIds,
];

export const wholeHouseInsulationDefaultLevelIds = [
	'wholeHouseInsulationLevel0',
	'wholeHouseInsulationLevel1',
] as const;

export const wholeHouseInsulationAdditionalLevelIds = [
	'wholeHouseInsulationLevel2',
	'wholeHouseInsulationLevel3',
	'wholeHouseInsulationLevel4',
	'wholeHouseInsulationLevel5',
	'wholeHouseInsulationLevel6',
	'wholeHouseInsulationLevel7',
] as const;

export const wholeHouseInsulationLevelIds = [
	...wholeHouseInsulationDefaultLevelIds,
	...wholeHouseInsulationAdditionalLevelIds,
];

export const wholeHouseDrywallDefaultLevelIds = [
	'wholeHouseDrywallLevel0',
	'wholeHouseDrywallLevel1',
] as const;

export const wholeHouseDrywallAdditionalLevelIds = [
	'wholeHouseDrywallLevel2',
	'wholeHouseDrywallLevel3',
	'wholeHouseDrywallLevel4',
	'wholeHouseDrywallLevel5',
	'wholeHouseDrywallLevel6',
	'wholeHouseDrywallLevel7',
] as const;

export const wholeHouseDrywallLevelIds = [
	...wholeHouseDrywallDefaultLevelIds,
	...wholeHouseDrywallAdditionalLevelIds,
];

export const wholeHouseMillworkDefaultLevelIds = [
	'wholeHouseMillworkLevel0',
	'wholeHouseMillworkLevel1',
] as const;

export const wholeHouseMillworkAdditionalLevelIds = [
	'wholeHouseMillworkLevel2',
	'wholeHouseMillworkLevel3',
	'wholeHouseMillworkLevel4',
	'wholeHouseMillworkLevel5',
	'wholeHouseMillworkLevel6',
	'wholeHouseMillworkLevel7',
] as const;

export const wholeHouseMillworkLevelIds = [
	...wholeHouseMillworkDefaultLevelIds,
	...wholeHouseMillworkAdditionalLevelIds,
];

export const wholeHouseInteriorFinishesDefaultLevelIds = [
	'wholeHouseInteriorFinishesLevel0',
	'wholeHouseInteriorFinishesLevel1',
] as const;

export const wholeHouseInteriorFinishesAdditionalLevelIds = [
	'wholeHouseInteriorFinishesLevel2',
	'wholeHouseInteriorFinishesLevel3',
	'wholeHouseInteriorFinishesLevel4',
	'wholeHouseInteriorFinishesLevel5',
	'wholeHouseInteriorFinishesLevel6',
	'wholeHouseInteriorFinishesLevel7',
] as const;

export const wholeHouseInteriorFinishesLevelIds = [
	...wholeHouseInteriorFinishesDefaultLevelIds,
	...wholeHouseInteriorFinishesAdditionalLevelIds,
];

export const wholeHouseExteriorFinishesDefaultLevelIds = [
	'wholeHouseExteriorFinishesLevel0',
	'wholeHouseExteriorFinishesLevel1',
] as const;

export const wholeHouseExteriorFinishesAdditionalLevelIds = [
	'wholeHouseExteriorFinishesLevel2',
	'wholeHouseExteriorFinishesLevel3',
	'wholeHouseExteriorFinishesLevel4',
	'wholeHouseExteriorFinishesLevel5',
	'wholeHouseExteriorFinishesLevel6',
	'wholeHouseExteriorFinishesLevel7',
] as const;

export const wholeHouseExteriorFinishesLevelIds = [
	...wholeHouseExteriorFinishesDefaultLevelIds,
	...wholeHouseExteriorFinishesAdditionalLevelIds,
];

export const wholeHouseIntWallCladdingDefaultLevelIds = [
	'wholeHouseIntWallCladdingLevel0',
	'wholeHouseIntWallCladdingLevel1',
] as const;

export const wholeHouseIntWallCladdingAdditionalLevelIds = [
	'wholeHouseIntWallCladdingLevel2',
	'wholeHouseIntWallCladdingLevel3',
	'wholeHouseIntWallCladdingLevel4',
	'wholeHouseIntWallCladdingLevel5',
	'wholeHouseIntWallCladdingLevel6',
	'wholeHouseIntWallCladdingLevel7',
] as const;

export const wholeHouseIntWallCladdingLevelIds = [
	...wholeHouseIntWallCladdingDefaultLevelIds,
	...wholeHouseIntWallCladdingAdditionalLevelIds,
];

export const wholeHouseExtWallCladdingDefaultLevelIds = [
	'wholeHouseExtWallCladdingLevel0',
	'wholeHouseExtWallCladdingLevel1',
] as const;

export const wholeHouseExtWallCladdingAdditionalLevelIds = [
	'wholeHouseExtWallCladdingLevel2',
	'wholeHouseExtWallCladdingLevel3',
	'wholeHouseExtWallCladdingLevel4',
	'wholeHouseExtWallCladdingLevel5',
	'wholeHouseExtWallCladdingLevel6',
	'wholeHouseExtWallCladdingLevel7',
] as const;

export const wholeHouseExtWallCladdingLevelIds = [
	...wholeHouseExtWallCladdingDefaultLevelIds,
	...wholeHouseExtWallCladdingAdditionalLevelIds,
];

export const wholeHouseIntFixturesDefaultLevelIds = [
	'wholeHouseIntFixturesLevel0',
	'wholeHouseIntFixturesLevel1',
] as const;

export const wholeHouseIntFixturesAdditionalLevelIds = [
	'wholeHouseIntFixturesLevel2',
	'wholeHouseIntFixturesLevel3',
	'wholeHouseIntFixturesLevel4',
	'wholeHouseIntFixturesLevel5',
	'wholeHouseIntFixturesLevel6',
	'wholeHouseIntFixturesLevel7',
] as const;

export const wholeHouseIntFixturesLevelIds = [
	...wholeHouseIntFixturesDefaultLevelIds,
	...wholeHouseIntFixturesAdditionalLevelIds,
];

export const ids = [
	...wholeHouseFoundationLevelIds,
	...wholeHouseFoundationBasementLevelIds,
	'wholeHouseBlockWork',
	...wholeHouseFramingLevelIds,
	...wholeHouseIntFramingLevelIds,
	...wholeHouseExtFramingLevelIds,
	'wholeHouseFramingMaterial',
	...wholeHouseFlooringLevelIds,
	...wholeHouseDecksAndPorchesLevelIds,
	...wholeHouseWindowsLevelIds,
	...wholeHouseDoorsLevelIds,
	...wholeHouseCeilingsLevelIds,
	...wholeHouseInsulationLevelIds,
	'wholeHouseRoofing',
	'wholeHouseEavesSoffits',
	'wholeHouseGutters',
	...wholeHouseDrywallLevelIds,
	...wholeHouseMillworkLevelIds,
	...wholeHouseInteriorFinishesLevelIds,
	...wholeHouseExteriorFinishesLevelIds,
	...wholeHouseIntWallCladdingLevelIds,
	...wholeHouseExtWallCladdingLevelIds,
	...wholeHouseIntFixturesLevelIds,
	'wholeHouseFireRatedSystems',
	'wholeHouseHardware',

	'wholeHouseDimensionalFloorRoofLayout',
	'wholeHouseOpenings',
	'wholeHouseFlatRoofing',
	'wholeHouseEwpFloorRoofLayout',
] as const;
